export const UPLOAD_FILES_LIMIT = 15;
